import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Title from 'common/title/Title';
import { SapId } from 'ui';

const MarginDiv = styled.div`
  margin: 0 20px;
`;

const getTitle = ({ navigation, title }) => {
  if (title) {
    return title;
  }
  if (navigation && navigation.title) {
    return navigation.title;
  }
  return null;
};

const Wrapper = ({ navigation, title, children }) => {
  const navTitle = getTitle({ navigation, title });
  // Try to transform title to Id.
  // If the title is not numerical, it will just display the title.
  // Otherwise, if it would be a SAP ID (e.g with order),
  // the leading zeroes will be deleted
  return (
    <SapId originalId={navTitle}>
      {displayTitle =>
        <Title title={displayTitle}>
          <MarginDiv>{children}</MarginDiv>
        </Title>
      }
    </SapId>
  );
};

Wrapper.propTypes = {
  navigation: PropTypes.object,
  title: PropTypes.string,
  children: PropTypes.node,
};

const mapStateToProps = state => ({
  navigation: state.navigation.navigationSelf,
});

export default connect(mapStateToProps, null)(Wrapper);
